import React, { useEffect } from 'react';
import { useUserContext, fetchWalletData, fetchWalletTransactions } from '../../app/protectedRoute/UserContext';
import { Container, Typography, CircularProgress, List, ListItem, ListItemText, Paper, Box } from '@mui/material';

const Wallet: React.FC = () => {
  const { state, dispatch } = useUserContext();
  const { walletBalance, walletTransactions, paymentLoading } = state; // Reusing paymentLoading for wallet for simplicity

  useEffect(() => {
    fetchWalletData(dispatch);
    fetchWalletTransactions(dispatch);
  }, [dispatch]);

  if (paymentLoading) {
    return (
      <Container maxWidth="md" sx={{ mt: 4, textAlign: 'center' }}>
        <CircularProgress />
        <Typography variant="h6">Loading wallet data...</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>My Wallet</Typography>
      <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
        <Typography variant="h5" color="primary">Current Balance: ₹{walletBalance !== null ? walletBalance.toFixed(2) : '0.00'}</Typography>
      </Paper>

      <Typography variant="h5" gutterBottom>Transaction History</Typography>
      <Paper elevation={3} sx={{ p: 3 }}>
        {walletTransactions.length === 0 ? (
          <Typography>No transactions found.</Typography>
        ) : (
          <List>
            {walletTransactions.map((transaction: any) => (
              <ListItem key={transaction.timestamp}>
                <ListItemText
                  primary={`Amount: ₹${transaction.amount.toFixed(2)}`}
                  secondary={`Type: ${transaction.transaction_type} | Date: ${new Date(transaction.timestamp).toLocaleString()}`}
                />
              </ListItem>
            ))}
          </List>
        )}
      </Paper>
    </Container>
  );
};

export default Wallet;
